import { Grid, Box } from '@mui/material';
import BackButton from '@apigrowfinance/pbolt-back-button';
import { useTheme } from '@apigrowfinance/pbolt-theme-provider';
import { useNavigate } from 'react-router-dom';

import { ITimelineItem } from '@clients/timelineClient';
import LoadingError from '@components/loadingError/LoadingError';
import TimelineDetailsBody from '@components/timelineDetails/TimelineDetailsBody';
import TimelineDetailsHeader from '@components/timelineDetails/TimelineDetailsHeader';

interface TimelineDetailsProps {
    timelineItem: ITimelineItem;
    isLoading?: boolean;
    isError?: boolean;
}

const TimelineDetails = ({
    timelineItem,
    isLoading = false,
    isError = false,
}: TimelineDetailsProps) => {
    const { theme } = useTheme();
    const navigate = useNavigate();

    return (
        <Grid container flexDirection="column">
            <Grid item xs={12}>
                <BackButton
                    text="Back"
                    iconSize={theme.spacing(2.75)}
                    buttonOptions={{
                        sx: {
                            mb: 2.875,
                            textTransform: 'none',
                            p: 0,
                            justifyContent: 'flex-start',
                        },
                    }}
                    textOptions={{ variant: 'overline' }}
                    onClick={() => {
                        navigate(-1);
                    }}
                />
            </Grid>
            {isError ? (
                <Box sx={{ mt: 10 }}>
                    <LoadingError />
                </Box>
            ) : (
                <>
                    <Grid
                        item
                        xs={12}
                        sx={{
                            bgcolor: theme?.palette?.background?.paper,
                            pt: 4.375,
                            pl: 2.625,
                            borderTopLeftRadius: theme.shape.borderRadius * 2,
                            borderTopRightRadius: theme.shape.borderRadius * 2,
                            py: 4,
                            px: 3,
                            mb: 0.25,
                        }}>
                        <TimelineDetailsHeader
                            timelineItem={timelineItem}
                            isLoading={isLoading}
                        />
                    </Grid>
                    <TimelineDetailsBody
                        timelineItem={timelineItem}
                        isLoading={isLoading}
                    />
                </>
            )}
        </Grid>
    );
};

export default TimelineDetails;
